import { EnvironmentType } from 'src/features';
import { BbEnv } from 'src/utils/bb-env';

export const envMap: { [bbEnv in BbEnv]: EnvironmentType } = {
  [BbEnv.Development]: EnvironmentType.DEV,
  [BbEnv.Test]: EnvironmentType.PROD, // Test is prod-like for application changes
  [BbEnv.Staging]: EnvironmentType.STAGING,
  [BbEnv.Integration]: EnvironmentType.STAGING,
  [BbEnv.Production]: EnvironmentType.PROD,
};

// Ideally we'll import directly from the hooks package, but we have a lot of
// references to this path in the codebase. Keep backwards compatibility until
// we can refactor those references.
export { useStatsigGate } from 'src/hooks/statsig';
